<template>
  <h1>Lisää kohde</h1>
</template>

<script>
export default {};
</script>

<style></style>
